import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var PhoneSupport = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.55 17.058v-.2C38.948 7.635 31.329.42 22.005.42 12.68.42 5.06 7.636 4.46 16.757c0 .401-.1.802-.1 1.203v9.321c0 .501.4.902.902.902h4.511a2.01 2.01 0 0 0 2.005-2.005V17.86a2.01 2.01 0 0 0-2.005-2.005H6.365c1.102-7.617 7.62-13.631 15.64-13.631s14.537 5.913 15.64 13.631h-3.51a2.01 2.01 0 0 0-2.004 2.005v8.319a2.01 2.01 0 0 0 2.005 2.004h3.208c-1.203 5.513-5.314 10.023-10.728 11.727-.5-.802-1.403-1.303-2.406-1.303H19.7a2.91 2.91 0 0 0-2.908 2.906A2.909 2.909 0 0 0 19.7 44.42h4.511c1.604 0 2.807-1.203 2.908-2.806 6.416-1.905 11.229-7.417 12.231-14.233.401-2.205.301-7.918.2-10.323Zm-29.676.701c.1 0 .2.1.2.2v8.32c0 .1-.1.2-.2.2h-3.71V17.86h3.71v-.1Zm15.44 23.855c0 .6-.502 1.102-1.104 1.102H19.7a1.112 1.112 0 0 1-1.103-1.102c0-.602.501-1.103 1.103-1.103h4.511c.502 0 .903.3 1.103.802 0 .2.1.2 0 .3Zm12.531-16.738c0 .5 0 1.002-.1 1.503h-3.509c-.1 0-.2-.1-.2-.2v-8.32c0-.1.1-.2.2-.2h3.61v7.216Z"
  }));
});
PhoneSupport.displayName = 'PhoneSupport';
PhoneSupport.defaultProps = {
  'aria-label': 'PhoneSupport'
};
export default PhoneSupport;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/PhoneSupport.js
// module id = 3869
// module chunks = 11